import Accordion from "./modules/Accordion";
import Animations from "./modules/Animations";
import BackToTop from "./modules/BackToTop";
import MegaMenu from "./modules/MegaMenu";
import Slideshow from "./modules/Slideshow";
import VideoLightbox from "./modules/VideoLightbox";

const accordion = new Accordion();
const animations = new Animations();
const backToTop = new BackToTop();
const megaMenu = new MegaMenu();
const slideShow = new Slideshow();
const lightbox = new VideoLightbox();